import { useEffect, useState } from 'react';
import OrgChooser from "./components/org-selector/org-selector.component";
import OtpPage from './components/otp/otp.component';
import { GetAllApps } from './components/services/auth.service';

import { ClearQueryStringCookies, CreateOtpQueryStringCookie, FetchTenantIdFromCookie, FetchTenantNameFromCookie } from "./components/services/cookie.service";

async function continueToApp(appName, clientCode, backendOtp) {
    const apps = await GetAllApps();
    const app = apps.find((item) => item.name === appName);
    if (!app) {
        throw new Error('Selected application is unavailable.');
    }
    if(appName === 'kds' || appName === 'dmb' || appName === 'board')
    {
        appName = appName === 'kds' ? 'kds' : 'board';
    }
    CreateOtpQueryStringCookie(clientCode, backendOtp, appName);
    let response;
    try {
            if (appName === 'kds' || appName === 'dmb' || appName === 'board') {
                const appNameSpace = appName === 'kds' ? 'kds' : 'board'; 
                const appInfoResponse = await fetch(`/${appNameSpace}/GetAppInfo/`, {
                method: 'GET',
                credentials: 'include'
            });
            if (!appInfoResponse || appInfoResponse.status !== 200) {
                throw new Error(`Invalid registration. Please try again.`);
            }
            const appInfo = await appInfoResponse.json();
            if (!appInfo || typeof appInfo !== 'object' || Array.isArray(appInfo) || Object.keys(appInfo).length === 0) {
                throw new Error('Invalid registration. Please try again.');
            }
        }
        response = await fetch(app.url, { credentials: 'include' });
    } catch (error) {
        if (error instanceof Error && error.message.startsWith('Unable to retrieve KDS app info')) {
            throw error;
        }
        throw new Error(`Invalid registration. Please try again.`);
    }
    if (response.status !== 200) {
        throw new Error('Invalid registration. Please try again.');
    }
    const html = await response.text();
    window.history.replaceState(null, '', app.url);
    window.document.open();
    window.document.write(html);
    window.document.close();
}

function App() {
    const [route, setRoute] = useState(window.location.hash.slice(1));
    useEffect(() => {
        const handleHashChange = () => setRoute(window.location.hash.slice(1));
        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    const [pathname, query] = route.split('?');
    const appName = new URLSearchParams(query).get('app');
    const isSupportedOtpApp = appName === 'kds' || appName === 'dmb';
    const returnHome = () => {
        ClearQueryStringCookies();
        window.history.replaceState(null, '', window.location.pathname || '/');
        setRoute('');
    };

    useEffect(() => {
        if (pathname !== '/otp' || isSupportedOtpApp) {
            return;
        }
        ClearQueryStringCookies();
        window.history.replaceState(null, '', window.location.pathname || '/');
        setRoute('');
    }, [pathname, isSupportedOtpApp]);

    if (pathname === '/otp') {
        if (!isSupportedOtpApp) {
            return null;
        }
        return <OtpPage
            appName={appName}
            onContinue={continueToApp}
            onVerified={continueToApp}
            onBack={returnHome}
        />;
    }

    return <OrgChooser OrgTenantId={FetchTenantIdFromCookie()} OrgName={FetchTenantNameFromCookie()} />
}

export default App